'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDeregisteringFlag = exports.setRegistrationNumber = exports.createRegistration = exports.getRegistrations = undefined;

var _getRegistrations2 = require('./getRegistrations');

var _getRegistrations3 = _interopRequireDefault(_getRegistrations2);

var _createRegistration2 = require('./createRegistration');

var _createRegistration3 = _interopRequireDefault(_createRegistration2);

var _setRegistrationNumber2 = require('./setRegistrationNumber');

var _setRegistrationNumber3 = _interopRequireDefault(_setRegistrationNumber2);

var _setDeregisteringFlag2 = require('./setDeregisteringFlag');

var _setDeregisteringFlag3 = _interopRequireDefault(_setDeregisteringFlag2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.getRegistrations = _getRegistrations3.default;
exports.createRegistration = _createRegistration3.default;
exports.setRegistrationNumber = _setRegistrationNumber3.default;
exports.setDeregisteringFlag = _setDeregisteringFlag3.default;


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/registrations/index.js
// module id = 107
// module chunks = 0